/* eslint-disable */
export default {
  forward: 'Renvoyer',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
